export default __webpack_public_path__ + "static/media/calendar-tabs.3e6e9963.svg";